<template>
  <defs>
    <component :is="'style'">
      <slot />
    </component>
  </defs>
</template>
